import { useState } from 'react';
import * as Yup from 'yup';

import { numberOfYearOptions } from 'components/organisms/contactsFilters/defaultFilters';
import { useLazyGetFilterOptionsQuery } from '../../../../../../services/contacts';

export const useIndustryFilter = ({ sharedList, orderBy, setFilters }) => {
  const [getFilterOptions] = useLazyGetFilterOptionsQuery();
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const formSchema = Yup.object().shape({
    industryTags: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.string().required(),
      }),
    ),
    industryTagsYears: Yup.object()
      .shape({
        label: Yup.string(),
        value: Yup.number(),
      })
      .nullable()
      .default(null),
  });

  const onSearchChange = async (currentValue) => {
    try {
      const data = await getFilterOptions({
        facet: 'industry_tags',
        query: currentValue,
        sharedList,
        orderBy,
      }).unwrap();

      return data ?? [];
    } catch (error) {
      return [];
    }
  };

  const onSubmit = ({ industryTags, industryTagsYears }) => {
    const filters = { industryTags };
    if (industryTags && industryTags.length > 0) {
      filters.industryTagsYears = industryTagsYears;
    }
    setFilters(filters);
  };

  const onMenuOpen = () => {
    setIsLoading(true);
    onSearchChange('').then((data) => {
      setDefaultOptions(data);
      setIsLoading(false);
    });
  };

  const getInitialValues = (industryTags, industryTagsYears) => {
    // If industryTagsYears is just a number, find the matching option
    let normalizedYears = industryTagsYears;
    if (typeof industryTagsYears === 'number') {
      normalizedYears = numberOfYearOptions.find((option) => option.value === industryTagsYears);
    }

    return {
      industryTags: industryTags || [],
      industryTagsYears: normalizedYears || numberOfYearOptions[0],
    };
  };

  return {
    formSchema,
    defaultOptions,
    isLoading,
    onMenuOpen,
    onSearchChange,
    onSubmit,
    getInitialValues,
  };
};
